// Group videos copy (NL + EN) — teacher upload on /grid and the staff video
// strip. Namespace `groupVideos` in src/lib/i18n. Keys identical in both
// languages (the NL object is typed against the EN one).

export const groupVideosEn = {
  trigger: 'Group video',
  record: '🎥 Record video',
  choose: '🎞️ Choose video',
  dialogTitle: 'Upload group video',
  dialogDescription: 'Max 90 seconds. The video is reduced to 720p on this phone before anything is sent.',
  groupLabel: 'Group',
  upload: 'Upload video',
  cancel: 'Cancel',
  compressing: 'Compressing… {{percent}}%',
  uploading: 'Uploading… {{percent}}%',
  keepOpen: 'Keep this screen open until the upload is done.',
  success: 'Video uploaded for {{group}}',
  stripTitle: 'Videos',
  play: 'Play video',
  remove: 'Remove',
  confirmRemove: 'Remove for good? Parents will no longer see this video.',
  confirmRemoveYes: 'Yes, remove',
  removed: 'Video removed',
  close: 'Close',
  seconds: '{{n}} s',
  errors: {
    no_webcodecs: 'This phone cannot compress videos yet. Update your phone (iOS or Chrome) and try again.',
    unreadable: 'This video cannot be read. Choose another video.',
    no_video_track: 'This file has no video. Choose another video.',
    too_long: 'This video is longer than 90 seconds. Trim it and try again.',
    unsupported: 'This video cannot be compressed on this phone. Try another video or update your phone.',
    audio_unsupported: 'The sound of this video cannot be processed on this phone. Update your phone and try again.',
    too_large: 'This video is still larger than 40 MB after compressing. Make it shorter.',
    forbidden: 'No permission to upload a video for this group on this device. Ask your location manager.',
    refused: 'The server refused this upload. Please try again.',
    upload_failed: 'Upload failed. Check your connection and try again.',
    not_found: 'This video no longer exists.',
    server: 'Something went wrong on the server. Please try again.',
    no_staff_identity: 'Select who you are (⇄) before uploading a video.',
    day_out_of_range: 'Videos can only be added for today or the last 14 days. Go to a day in that range.',
    generic: 'Upload failed. Please try again.',
    load: 'Videos could not be loaded.',
    play: 'This video cannot be played right now.',
  },
};

export type GroupVideosDictionary = typeof groupVideosEn;

export const groupVideosNl: GroupVideosDictionary = {
  trigger: 'Groepsvideo',
  record: '🎥 Video opnemen',
  choose: '🎞️ Video kiezen',
  dialogTitle: 'Groepsvideo uploaden',
  dialogDescription: 'Max 90 seconden. De video wordt op deze telefoon verkleind tot 720p voordat er iets verstuurd wordt.',
  groupLabel: 'Groep',
  upload: 'Video uploaden',
  cancel: 'Annuleren',
  compressing: 'Verkleinen… {{percent}}%',
  uploading: 'Uploaden… {{percent}}%',
  keepOpen: 'Houd dit scherm open tot de upload klaar is.',
  success: 'Video geüpload voor {{group}}',
  stripTitle: "Video's",
  play: 'Video afspelen',
  remove: 'Verwijderen',
  confirmRemove: 'Definitief verwijderen? Ouders zien deze video dan niet meer.',
  confirmRemoveYes: 'Ja, verwijderen',
  removed: 'Video verwijderd',
  close: 'Sluiten',
  seconds: '{{n}} s',
  errors: {
    no_webcodecs: "Deze telefoon kan nog geen video's verkleinen. Werk je telefoon bij (iOS of Chrome) en probeer het opnieuw.",
    unreadable: 'Deze video kan niet gelezen worden. Kies een andere video.',
    no_video_track: 'Dit bestand bevat geen video. Kies een andere video.',
    too_long: 'Deze video is langer dan 90 seconden. Kort hem in en probeer het opnieuw.',
    unsupported: 'Deze video kan op deze telefoon niet verkleind worden. Probeer een andere video of werk je telefoon bij.',
    audio_unsupported: 'Het geluid van deze video kan op deze telefoon niet verwerkt worden. Werk je telefoon bij en probeer het opnieuw.',
    too_large: 'Deze video is na het verkleinen nog groter dan 40 MB. Maak hem korter.',
    forbidden: 'Geen rechten om op dit apparaat een video voor deze groep te uploaden. Vraag je locatiebeheerder.',
    refused: 'De server heeft deze upload geweigerd. Probeer het opnieuw.',
    upload_failed: 'Upload mislukt. Controleer je verbinding en probeer het opnieuw.',
    not_found: 'Deze video bestaat niet meer.',
    server: 'Er ging iets mis op de server. Probeer het opnieuw.',
    no_staff_identity: 'Kies eerst wie je bent (⇄) voordat je een video uploadt.',
    day_out_of_range: "Video's kun je alleen toevoegen voor vandaag of de afgelopen 14 dagen. Ga naar een dag in die periode.",
    generic: 'Upload mislukt. Probeer het opnieuw.',
    load: "Video's konden niet geladen worden.",
    play: 'Deze video kan nu niet afgespeeld worden.',
  },
};
